export const projectsData = [
    {
        id: 1,
        projectName: 'E-Commerce Website',
        projectDesc: 'An E-commerce Platform which uses MERN as tech. stack',
        tags: ['NodeJs','ReactJs','MongoDB'],
        code: 'https://github.com/arijit2002/redknot_backend',
        demo: 'https://redknot-customer.vercel.app/',
        image: "https://raw.githubusercontent.com/arijit2002/redknot_backend/main/Capture1.JPG"
    },
    {
        id: 2,
        projectName: 'Banking Management System',
        projectDesc: 'An online Banking Management System Web Application which has a separate Client and Admin Panel and uses MERN as tech. stack',
        tags: ['NodeJs','ReactJs','MongoDB','Auth0'],
        code: 'https://github.com/arijit2002/modernbank-client-frontend',
        demo: 'https://banking-react-client-side.vercel.app/',
        image: "https://raw.githubusercontent.com/arijit2002/modernbank-client-frontend/main/Bank.JPG"
    },
    {
        id: 3,
        projectName: 'Product Management System',
        projectDesc: 'In this project, we can perform CRUD operations on product datas. It has alos got user registration and login system for providing privileges to the users.',
        tags: ['Java','Thymeleaf','Spring Boot','Spring Security','HTML','CSS'],
        code: 'https://github.com/arijit2002/Product-Management-System-PostgreSQL',
        demo: 'https://productmanagement-system.herokuapp.com/',
        image: "https://raw.githubusercontent.com/arijit2002/Product-Management-System-PostgreSQL/arijit-sec/product.JPG"
    },
    {
        id: 4,
        projectName: 'Crime Lab of India',
        projectDesc: 'In this Data Analysis, the main concept is to display all the crime list in INDIA from year 2001 to 2012 from an existing dataset.',
        tags: ['Python','Flask','Matplotlib','Pandas'],
        code: 'https://github.com/arijit2002/crime_lab',
        demo: 'https://crime-lab.onrender.com/',
        image: "https://raw.githubusercontent.com/arijit2002/crime_lab/main/Capture.JPG"
    },
    {
        id: 5,
        projectName: 'Weather',
        projectDesc: 'It displays the CURRENT WEATHER of the mentioned city given as an input in the search box.',
        tags: ['Python', 'Flask', 'Javascript', "HTML","CSS"],
        code: 'https://github.com/arijit2002/weather',
        demo: 'https://weather--search.herokuapp.com/',
        image: "https://raw.githubusercontent.com/arijit2002/weather/main/screenshots/home.JPG"
    }
]
